<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="body-rw Part-rw exclude-auto-rw page-open-right-rw" epub:type="bodymatter part" id="Part1">
<div class="title-block-rw" id="title-block4">
<p class="title-num-rw" id="title-num1"><a href="#/TOC">one</a></p>
</div>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// s006-Part-001.vue?52ddb0df